import { baseQuery } from "./baseQuery";
import { createApi } from "@reduxjs/toolkit/query/react";
import { FileName } from "../constants/common.constants";
import { ReceivableDownloadRequest } from "../shared/models/receivables.model";
import { DataResponse } from "../shared/models";

export const receivableService = createApi({
  reducerPath: "receivableService",
  baseQuery: baseQuery,
  endpoints: (builder) => ({
    getReceivable: builder.query<any, any>({
      query: (params) => ({
        url: `/receivable`,
        params,
        method: "GET",
        headers: {
          PageName: "Receivable",
        },
      }),
    }),
    getReceivableDetail: builder.query<any, { id: string }>({
      query: ({id}) => ({
        url: `/receivable/${id}`,
        method: "GET",
        headers: {
          PageName: "Receivable",
        },
      }),
    }),
    updateReceivable: builder.mutation<any, any>({
      query: (body) => ({
        url: `/receivable/${body.id}`,
        body: body,
        method: "PUT",
        headers: {
          PageName: "Receivable",
        },
      }),
    }),
    downloadReceivables: builder.query<any, ReceivableDownloadRequest>({
      query: ({ nameMerchant, ...others }) => ({
        url: `/receivable/download`,
        method: "GET",
        params: others,
        headers: {
          PageName: "Receivable",
        },
      }),
    }),
    getReceivablePayout: builder.query<any, { id: string }>({
      query: ({ id }) => ({
        url: `/receivable/${id}/payout`,
        method: "GET",
        headers: {
          PageName: "Receivable",
        },
      }),
    }),
    moveReceivable: builder.mutation<DataResponse<any>, any>({
      query: (body: any) => ({
        url: `/receivable/moveReceivable`,
        body,
        method: "POST",
        headers: {
          PageName: "Receivable",
        },
      }),
    }),
  }),
});

export const {
  useLazyGetReceivableQuery,
  useLazyGetReceivableDetailQuery,
  useUpdateReceivableMutation,
  useLazyDownloadReceivablesQuery,
  useLazyGetReceivablePayoutQuery,
  useMoveReceivableMutation,
} = receivableService;
